
<template>
  <v-container fluid>

    <v-data-table
        :headers="tableHeaders"
        :items="whitelist"
        class="elevation-1"
        :loading="loading"
        :options.sync="options"
        :server-items-length="100"
        disable-sort
    >
      <template v-slot:top>
        <v-toolbar
            flat
        >
          <v-toolbar-title>Whitelisted Users</v-toolbar-title>
          <v-divider
              class="mx-4"
              inset
              vertical
          ></v-divider>
          <v-spacer></v-spacer>
          <v-dialog
              v-model="dialog"
              max-width="500px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
              >
                New User
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col
                        cols="12"

                    >
                      <v-text-field
                          v-model="editedItem.username"
                          label="Username"
                          :disabled="!isNewItem"
                      ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"

                    >
                      <v-checkbox
                          v-model="editedItem.ignore_adult_promoter_detection"
                          label="Ignore Adult Promoter"
                      ></v-checkbox>
                    </v-col>
                    <v-col
                        cols="12"

                    >
                      <v-checkbox
                          v-model="editedItem.ignore_high_volume_repost_detection"
                          label="Ignore High Volume"
                      ></v-checkbox>
                    </v-col>
                    <v-col
                        cols="12"

                    >
                      <v-checkbox
                          v-model="editedItem.ignore_repost_detection"
                          label="Ignore Repost"
                      ></v-checkbox>
                    </v-col>

                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="close"
                >
                  Cancel
                </v-btn>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="save"
                >
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
            small
            @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
      </template>

      <template v-slot:item.ignore_adult_promoter_detection="{ item }">
        <v-simple-checkbox v-model="item.ignore_adult_promoter_detection" disabled></v-simple-checkbox>
      </template>
      <template v-slot:item.ignore_high_volume_repost_detection="{ item }">
        <v-simple-checkbox v-model="item.ignore_high_volume_repost_detection" disabled></v-simple-checkbox>
      </template>
      <template v-slot:item.ignore_repost_detection="{ item }">
        <v-simple-checkbox v-model="item.ignore_repost_detection" disabled></v-simple-checkbox>
      </template>

    </v-data-table>
  </v-container>
</template>
<script>

import {RepositoryFactory} from "@/services/api/RepositoryFactory";

const WhitelistRepo = RepositoryFactory.get('userWhitelist');

export default {
  name: "UserWhitelist",
  props: {
    subredditName: String
  },
  data: () => ({
    whitelist: [],
    loading: true,
    options: {},
    dialog: false,
    dialogDelete: false,
    editedIndex: -1,
    editedItem: {},
    tableHeaders: [
      {text: 'User', value: 'username'},
      {text: 'Adult Promoter Ignore', value: 'ignore_adult_promoter_detection'},
      {text: 'High Volume Ignore', value: 'ignore_high_volume_repost_detection'},
      {text: 'Repost Ignore', value: 'ignore_repost_detection'},
      { text: 'Edit', value: 'actions', sortable: false },
    ]

  }),
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Whitelisted User' : 'Edit Whitelisted User'
    },
    isNewItem() {
      return this.editedIndex === -1;
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    dialogDelete (val) {
      val || this.closeDelete()
    },
  },

  mounted() {
    this.loadWhitelist();
  },
  methods: {
    loadWhitelist() {
      this.loading = true;
      WhitelistRepo.getUserWhitelist({params: {token: this.$store.getters.token}}, this.subredditName)
          .then(res => {
            if (res.status === 'error') {
              this.$emit('on-alert', {color: 'error', message: res.data})
              this.loading = false;
              return;
            }
            this.whitelist = res.data;
            this.loading = false;
          })
    },
    editItem (item) {
      this.editedIndex = this.whitelist.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      this.editedIndex = this.whitelist.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDelete = true
    },

    deleteItemConfirm () {

      WhitelistRepo.deleteUserWhitelist(this.subredditName, {params: {token: this.$store.getters.token, id: this.editedItem.id}})
          .then(res => {
            if (res.status === 'error') {
              this.$emit('on-alert', {color: 'error', message: res.data})
              return;
            }
            this.loadWhitelist();
          })
      this.closeDelete()
    },

    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    closeDelete () {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    save () {
      if (this.editedIndex > -1) {
        WhitelistRepo.updateUserWhitelist(this.subredditName, this.editedItem, {params: {token: this.$store.getters.token}})
            .then(res => {
              if (res.status === 'error') {
                this.$emit('on-alert', {color: 'error', message: res.data})
                return;
              }
              this.loadWhitelist();
            })
      } else {
        WhitelistRepo.createUserWhitelist(this.subredditName, this.editedItem, {params: {token: this.$store.getters.token}})
            .then(res => {
              if (res.status === 'error') {
                this.$emit('on-alert', {color: 'error', message: res.data})
                return;
              }
              this.loadWhitelist();
            })
      }
      this.close()
    },
  },
}
</script>

<style scoped>

</style>
